import { CurrentSubscriptionStatus } from "@outschool/gql-backend-generated";

import { useEsaMembershipCreditBalances } from "./useEsaMembershipCreditBalance";
import { useSubscriptionCreditBalance } from "./useSubscriptionCreditBalance";

/**
 * Hook to determine if a user has ESA credits but no paid Outschool subscription.
 * This is used to show full credit prices instead of "Free for members" for ESA users
 * who don't have paid memberships.
 */
export function useEsaUserWithoutPaidMembership() {
  const { hasEsaMembershipCreditBalances } = useEsaMembershipCreditBalances();
  const { currentStatus } = useSubscriptionCreditBalance();

  // User has paid subscription if they have an active subscription (not paused/canceled)
  const hasPaidSubscription =
    currentStatus === CurrentSubscriptionStatus.Active;

  // User is ESA user without paid membership if:
  // 1. They have ESA credits
  // 2. They don't have a paid subscription
  const isEsaUserWithoutPaidMembership =
    hasEsaMembershipCreditBalances && !hasPaidSubscription;

  return {
    isEsaUserWithoutPaidMembership,
    hasEsaCredits: hasEsaMembershipCreditBalances,
    hasPaidSubscription,
  };
}
